<template>
  <div><homeHero /><aboutMe /><skillSection /><myProjects /></div>
</template>
<script>
import homeHero from "../components/home/homeHero.vue";
import aboutMe from "../components/home/aboutMe.vue";
import skillSection from "../components/home/skill/skillSection.vue";
import myProjects from "../components/home/myProjects.vue";
export default {
  name: "my-home",
  components: { homeHero, aboutMe, skillSection, myProjects },
};
</script>
